import { adobeDataLayerTrack, webPageDetails } from './analytics';
import { coveoToken } from './coveo';
import { coveoAnalytics } from './coveo-analytics';
import {
  Authenticated,
  CoveoCoachmarkClicked,
  CoveoCoachmarkDismissed,
  CoveoCoachmarkDisplayed,
  Docs,
  Error,
  JWT,
  Learn,
  Microsite,
  Start,
} from './keys';
import { log } from './log';
import { mode } from './mode';
import { o } from './observable';
import { docs, error, locale, microsite, root } from './page';
import { profile } from './profile';
import { region } from './region';
import { r, router } from './router';
import { orchestrate } from '../app/utils/orchestrate';
import { isLoggedInUser } from './auth';
import { appShadowRoot } from './elements';
/*
 * Maintenance banner - TODO: Enable maintenance banner
 * Last Update UGP-11814 08/08/2024
 * import {maintenanceBanner} from './maintenance-banner';
 *
 */

function skip(arg = '', invalid = []) {
  return arg.length === 0 || invalid.length === 0 || invalid.some((i) => arg.startsWith(i));
}

export async function wire(routerConfig = {}) {
  // Forced purge of state
  if (JWT in sessionStorage) {
    sessionStorage.removeItem(JWT);
  }

  router(routerConfig);
  log(`Created router (${r.active ? 'active' : 'inactive'})`);

  o.once(Start, async () => {
    const coveoSearchbox = appShadowRoot.querySelector('#CoveoSearchBox');
    if (coveoSearchbox) {
      Coveo.initSearchbox(appShadowRoot.querySelector('#support #CoveoSearchBox'), fullSearchPagePath);
    }

    if (root === false) {
      // adobeDataLayerTrack({
      //   event: 'page loaded',
      //   web: {
      //     webPageDetails: await webPageDetails(
      //       '',
      //       void 0,
      //       void 0,
      //       error ? Error : docs ? Docs : microsite ? Microsite : Learn,
      //       "newtest61"
      //     ),
      //   },
      // });
      log('Tracked navigation');
    }
  });

  // Coachmarks events
  for (const [event, verb] of [
    [CoveoCoachmarkClicked, 'clicked'],
    [CoveoCoachmarkDismissed, 'dismissed'],
    [CoveoCoachmarkDisplayed, 'displayed'],
  ]) {
    o.on(event, () => {
      adobeDataLayerTrack({
        event,
        web: {
          webInteraction: {
            linkClicks: {
              value: 1,
            },
          },
        },
        link: {
          linkTitle: `coachmark ${verb}`,
          linkLocation: 'coachmark',
          linkType: 'other',
          destinationDomain: location.hostname,
        },
      });
    });
  }

  // Interop
  locale();

  const authenticated = await isLoggedInUser();

  const skipPaths = ['/docs/customer-one/'];

  sessionStorage.setItem(Authenticated, authenticated);

  const data = authenticated ? await profile() : void 0;

  o.off('ready'); // handles timeout in ims.js
  o.dispatch('auth', data);

  if (authenticated) {
    log('User is signed in');

    if (root || docs || error || microsite) {
      try {
        mode(data);
      } catch (err) {
        log(`Changing UI to authenticated mode() failed: ${err.stack}`);
      }
    }
  } else {
    log('User is not signed in');
  }

  const url = new URL(location.href);
  if (root || url.searchParams.has('recommended')) {
    await orchestrate();
  }

  region().then(() => {
    if (skip(location.pathname, skipPaths) === false) {
      if (docs) {
        coveoAnalytics(data);
      }
    }
  });

  await coveoToken(data);

  log('Dispatching "start" event');
  o.dispatch('start', data);

  /*
   * Maintenance banner - TODO: Enable maintenance banner
   * Last Update UGP-11814 08/08/2024
   * maintenanceBanner();
   */
}
